import './Services.css';

const Services = () => {
  return (
    <section id="services">
      <div className="services-content">
        <h2 className="services-title">Our Services</h2>
        <div className="services-grid">
          {[
            { title: 'Elite Training', desc: 'One-on-one coaching with top trainers to craft your perfect fitness plan.' },
            { title: 'Group Classes', desc: 'Vibe in high-octane classes like Boxing, Spin, and Power Yoga.' },
            { title: '24/7 Gym', desc: 'Access premium weights, cardio, and functional gear any time of day.' }
          ].map(service => (
            <div key={service.title} className="service-card">
              <h3 className="service-card-title">{service.title}</h3>
              <p className="service-card-desc">{service.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;